import { status } from '@/alas';
import { defineComponent, reactive, computed } from '@vue/composition-api';
export default defineComponent({
    setup(props, context) {
        // ================
        //
        // state
        //
        let $ = reactive({
            max: 4,
            farm: status.fetch('farm'),
            cycle: status.fetch('cycle'),
            pictures: status.fetch('pictures')
        });
        // ================
        //
        // computed
        //
        let done = computed(() => $.pictures.o.fetchArchived.done);
        let error = computed(() => $.pictures.o.fetchArchived.error);
        let items = computed(() => $.pictures.items);
        // ================
        //
        // mounted
        //
        let addMax = () => {
            $.max += 4;
        };
        // ================
        //
        // done
        //
        return {
            $,
            done,
            error,
            items,
            addMax
        };
    }
});
